<template>
  <span class="select-component">
    <select id="make" name="make" v-model="selectedMake" data-cf-makeselect @change="selectMake"
          >
      <option value="">{{label}}</option>
      <option v-for="(models, make) in options" :name="make" :key="make" :data-label="make" :value="make">{{make}}</option>
    </select>
  </span>
</template>

<script>
export default {
  name: "Make",
  props: {
    label: {
      type: String
    },
    preselect: {
      type: String
    },
    options: {
      type: [Array, Object]
    }
  },
  data() {
    return {
      selectedMake: this.preselect,
    }
  },
  methods: {

    selectMake() {
      this.$emit("inputData", this.selectedMake);
    }
  },
  created() {

    this.selectMake()
  },
}
</script>

<style scoped>

</style>